// Let the browser draw before heavy main-thread work (I-1a Batch 4, IP2-29 (4)):
// "Opening…" must be on screen before Argon2id (~1 s on the slowest phone) runs.
// One animation frame gets the paint scheduled; the timeout lets it happen.

export function nextFrame(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      setTimeout(resolve, 0)
    })
  })
}
